var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"setting-main-wrapper"},[_c('div',{staticClass:"shop-side-auth"},[_c('div',{staticClass:"privacy-policy-page mb-3"},[_c('div',{staticClass:"back-to-login-page"},[_c('router-link',{attrs:{"to":"/login"}},[_vm._v("Back to Login")])],1),_c('PolicyTop'),_c('Definitions')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }